import { render } from "./ViewLoader.vue?vue&type=template&id=42ecf670&scoped=true"
const script = {}

import "./ViewLoader.vue?vue&type=style&index=0&id=42ecf670&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ecf670"]])

export default __exports__